module.exports = __webpack_public_path__ + "media/images/wines/Weißburgunder_Lehm-4fdc29dc46d20eea129220d7aba6c152.jpg";